
export const eyesvg = (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5267 13.5002C17.5267 15.7277 15.7267 17.5277 13.4992 17.5277C11.2717 17.5277 9.47168 15.7277 9.47168 13.5002C9.47168 11.2727 11.2717 9.47266 13.4992 9.47266C15.7267 9.47266 17.5267 11.2727 17.5267 13.5002Z"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4984 22.8043C17.4696 22.8043 21.1709 20.4643 23.7471 16.4143C24.7596 14.828 24.7596 12.1618 23.7471 10.5755C21.1709 6.52555 17.4696 4.18555 13.4984 4.18555C9.52711 4.18555 5.82586 6.52555 3.24961 10.5755C2.23711 12.1618 2.23711 14.828 3.24961 16.4143C5.82586 20.4643 9.52711 22.8043 13.4984 22.8043Z"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const warningsvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 15C11.7348 15 11.4804 15.1054 11.2929 15.2929C11.1054 15.4804 11 15.7348 11 16C11 16.2652 11.1054 16.5196 11.2929 16.7071C11.4804 16.8946 11.7348 17 12 17C12.2652 17 12.5196 16.8946 12.7071 16.7071C12.8946 16.5196 13 16.2652 13 16C13 15.7348 12.8946 15.4804 12.7071 15.2929C12.5196 15.1054 12.2652 15 12 15ZM12 6C11.7551 6.00003 11.5187 6.08996 11.3356 6.25272C11.1526 6.41547 11.0357 6.63975 11.007 6.883L11 7V13C11.0003 13.2549 11.0979 13.5 11.2728 13.6854C11.4478 13.8707 11.687 13.9822 11.9414 13.9972C12.1958 14.0121 12.4464 13.9293 12.6418 13.7657C12.8373 13.6021 12.9629 13.3701 12.993 13.117L13 13V7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6Z"
      fill="#BF3636"
    />
  </svg>
);

export const closesvg = (
(<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clipPath="url(#clip0_751_59708)">
    <mask
      id="mask0_751_59708"
      style={{ maskType: "alpha" }} // Corrected style prop
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="26"
      height="26"
    >
      <path
        d="M13 0C5.811 0 0 5.811 0 13C0 20.189 5.811 26 13 26C20.189 26 26 20.189 26 13C26 5.811 20.189 0 13 0ZM13 23.4C7.267 23.4 2.6 18.733 2.6 13C2.6 7.267 7.267 2.6 13 2.6C18.733 2.6 23.4 7.267 23.4 13C23.4 18.733 18.733 23.4 13 23.4ZM17.667 6.5L13 11.167L8.333 6.5L6.5 8.333L11.167 13L6.5 17.667L8.333 19.5L13 14.833L17.667 19.5L19.5 17.667L14.833 13L19.5 8.333L17.667 6.5Z"
        fill="#BF3636"
      />
    </mask>
    <g mask="url(#mask0_751_59708)">
      <rect x="-3" y="-5" width="32" height="36" fill="white" />
    </g>
  </g>
  <defs>
    <clipPath id="clip0_751_59708">
      <rect width="26" height="26" fill="white" />
    </clipPath>
  </defs>
</svg>

  )



);

export const closedeyesvg = (
  <svg
    width="27"
    height="28"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3454 11.1539L10.6529 16.8464C9.92168 16.1152 9.47168 15.1139 9.47168 14.0002C9.47168 11.7727 11.2717 9.97266 13.4992 9.97266C14.6129 9.97266 15.6142 10.4227 16.3454 11.1539Z"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.0459 6.99031C18.0771 5.50531 15.8271 4.69531 13.4984 4.69531C9.52711 4.69531 5.82586 7.03531 3.24961 11.0853C2.23711 12.6716 2.23711 15.3378 3.24961 16.9241C4.13836 18.3191 5.17336 19.5228 6.29836 20.4903"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.47168 22.4719C10.7542 23.0119 12.1154 23.3044 13.4992 23.3044C17.4704 23.3044 21.1717 20.9644 23.7479 16.9144C24.7604 15.3281 24.7604 12.6619 23.7479 11.0756C23.3767 10.4906 22.9717 9.93938 22.5554 9.42188"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4489 14.7871C17.1564 16.3734 15.8626 17.6671 14.2764 17.9596"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6537 16.8457L2.25 25.2495"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.7514 2.75L16.3477 11.1537"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const googleIconsvg = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.64 9.20419C17.64 8.56601 17.5827 7.95237 17.4764 7.36328H9V10.8446H13.8436C13.635 11.9696 13.0009 12.9228 12.0477 13.561V15.8192H14.9564C16.6582 14.2524 17.64 11.9451 17.64 9.20419Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99976 18.0009C11.4298 18.0009 13.467 17.195 14.9561 15.8205L12.0475 13.5623C11.2416 14.1023 10.2107 14.4214 8.99976 14.4214C6.65567 14.4214 4.67158 12.8382 3.96385 10.7109H0.957031V13.0428C2.43794 15.9841 5.48158 18.0009 8.99976 18.0009Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.96409 10.7108C3.78409 10.1708 3.68182 9.59398 3.68182 9.0008C3.68182 8.40762 3.78409 7.8308 3.96409 7.2908V4.95898H0.957273C0.347727 6.17398 0 7.54853 0 9.0008C0 10.4531 0.347727 11.8276 0.957273 13.0426L3.96409 10.7108Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99976 3.57955C10.3211 3.57955 11.5075 4.03364 12.4402 4.92545L15.0216 2.34409C13.4629 0.891818 11.4257 0 8.99976 0C5.48158 0 2.43794 2.01682 0.957031 4.95818L3.96385 7.29C4.67158 5.16273 6.65567 3.57955 8.99976 3.57955Z"
      fill="#EA4335"
    />
  </svg>
);

export const facebooksvg = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_950_18195)">
      <path
        d="M24 12C24 5.376 18.624 0 12 0C5.376 0 0 5.376 0 12C0 17.808 4.128 22.644 9.6 23.76V15.6H7.2V12H9.6V9C9.6 6.684 11.484 4.8 13.8 4.8H16.8V8.4H14.4C13.74 8.4 13.2 8.94 13.2 9.6V12H16.8V15.6H13.2V23.94C19.26 23.34 24 18.228 24 12Z"
        fill="#2F57BF"
      />
    </g>
    <defs>
      <clipPath id="clip0_950_18195">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const applesvg = (
  <svg
    width="19"
    height="24"
    viewBox="0 0 19 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.17065 5.26154C10.1587 5.26154 11.3972 4.5658 12.1348 3.63814C12.8027 2.79746 13.2898 1.62339 13.2898 0.449332C13.2898 0.289891 13.2759 0.130451 13.248 0C12.1487 0.0434838 10.8267 0.768213 10.0334 1.73935C9.40723 2.47858 8.83667 3.63814 8.83667 4.8267C8.83667 5.00064 8.8645 5.17457 8.87842 5.23255C8.948 5.24705 9.05933 5.26154 9.17065 5.26154ZM5.69165 22.8C7.0415 22.8 7.63989 21.8578 9.32373 21.8578C11.0354 21.8578 11.4111 22.771 12.9141 22.771C14.3892 22.771 15.3772 21.3505 16.3096 19.9591C17.3533 18.3647 17.7847 16.7992 17.8125 16.7268C17.7151 16.6978 14.8901 15.4947 14.8901 12.1175C14.8901 9.18957 17.1167 7.87057 17.2419 7.7691C15.7668 5.56592 13.5264 5.50795 12.9141 5.50795C11.2581 5.50795 9.9082 6.55156 9.05933 6.55156C8.14087 6.55156 6.93018 5.56593 5.49683 5.56593C2.76929 5.56593 0 7.91405 0 12.3494C0 15.1034 1.02979 18.0168 2.29614 19.9011C3.38159 21.4955 4.32788 22.8 5.69165 22.8Z"
      fill="#282828"
    />
  </svg>
);

export const microsoftsvg = (
  <svg
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 1.5H1V10.5H10V1.5Z" fill="#F25022" />
    <path d="M10 11.5H1V20.5H10V11.5Z" fill="#00A4EF" />
    <path d="M20 1.5H11V10.5H20V1.5Z" fill="#7FBA00" />
    <path d="M20 11.5H11V20.5H20V11.5Z" fill="#FFB900" />
  </svg>
);

export const registerArrowLeftSvg = (
  <svg
    width="45"
    height="44"
    viewBox="0 0 45 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: "10px" }}
  >
    <mask
      id="mask0_1277_40934"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="0"
      width="44"
      height="44"
    >
      <path
        d="M22.9993 0.333984C34.981 0.333984 44.666 10.019 44.666 22.0007C44.666 33.9823 34.981 43.6673 22.9993 43.6673C11.0177 43.6673 1.33268 33.9823 1.33268 22.0007C1.33268 10.019 11.0177 0.333984 22.9993 0.333984ZM22.9993 39.334C32.5543 39.334 40.3327 31.5557 40.3327 22.0007C40.3327 12.4457 32.5543 4.66732 22.9993 4.66732C13.4443 4.66732 5.66602 12.4457 5.66602 22.0007C5.66602 31.5557 13.4443 39.334 22.9993 39.334Z"
        fill="#BF3636"
      />
    </mask>
    <g mask="url(#mask0_1277_40934)">
      <rect
        width="55.3846"
        height="60.9231"
        transform="matrix(-1 0 0 1 50.1924 -8.46094)"
        fill="white"
      />
    </g>
    <path
      d="M34 23.5C34.8284 23.5 35.5 22.8284 35.5 22C35.5 21.1716 34.8284 20.5 34 20.5V23.5ZM10.9393 20.9393C10.3536 21.5251 10.3536 22.4749 10.9393 23.0607L20.4853 32.6066C21.0711 33.1924 22.0208 33.1924 22.6066 32.6066C23.1924 32.0208 23.1924 31.0711 22.6066 30.4853L14.1213 22L22.6066 13.5147C23.1924 12.9289 23.1924 11.9792 22.6066 11.3934C22.0208 10.8076 21.0711 10.8076 20.4853 11.3934L10.9393 20.9393ZM34 20.5H12V23.5H34V20.5Z"
      fill="white"
    />
  </svg>
);

export const bigCheckMark = (
  <svg
    width="168"
    height="164"
    viewBox="0 0 168 164"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M85.864 1.24219C130.523 1.24219 166.622 37.3408 166.622 81.9998C166.622 126.659 130.523 162.757 85.864 162.757C41.2051 162.757 5.10643 126.659 5.10643 81.9998C5.10643 37.3408 41.2051 1.24219 85.864 1.24219ZM85.864 146.606C121.478 146.606 150.47 117.614 150.47 81.9998C150.47 46.3857 121.478 17.3937 85.864 17.3937C50.2499 17.3937 21.2579 46.3857 21.2579 81.9998C21.2579 117.614 50.2499 146.606 85.864 146.606Z"
      fill="white"
    />
    <path
      d="M73.1178 111.815L52.3203 89.4733L61.7981 79.2916L73.1178 91.488L106.206 55.9062L115.684 66.0879L73.1178 111.815Z"
      fill="white"
    />
  </svg>
);

export const quotesvg = (
  <svg
    width="74"
    height="52"
    viewBox="0 0 74 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3868 29.1247C25.0368 32.3497 24.1035 34.9247 22.4785 37.208C20.2993 40.2538 16.6452 43.0997 10.6035 46.1247C10.2159 46.2951 9.867 46.5424 9.57792 46.8518C9.28885 47.1611 9.06564 47.526 8.92186 47.9242C8.77808 48.3224 8.71673 48.7457 8.74152 49.1684C8.76631 49.5911 8.87673 50.0043 9.06607 50.383C9.25542 50.7617 9.51974 51.0979 9.843 51.3714C10.1663 51.6448 10.5417 51.8497 10.9466 51.9736C11.3514 52.0975 11.7772 52.1379 12.1981 52.0922C12.6191 52.0466 13.0263 51.9158 13.3952 51.708C19.8535 48.483 24.5327 45.0788 27.5618 40.833C30.6493 36.5163 31.791 31.6538 31.791 25.9997V7.24967C31.791 5.3158 31.0228 3.46114 29.6553 2.09369C28.2879 0.726235 26.4332 -0.0419922 24.4993 -0.0419922H7.83268C5.89881 -0.0419922 4.04415 0.726235 2.6767 2.09369C1.30924 3.46114 0.541016 5.3158 0.541016 7.24967V21.833C0.541016 25.858 3.80768 29.1247 7.83268 29.1247H25.3868ZM67.0535 29.1247C66.7035 32.3497 65.7702 34.9247 64.1452 37.208C61.966 40.2538 58.3118 43.0997 52.2702 46.1247C51.8826 46.2951 51.5337 46.5424 51.2446 46.8518C50.9555 47.1611 50.7323 47.526 50.5885 47.9242C50.4448 48.3224 50.3834 48.7457 50.4082 49.1684C50.433 49.5911 50.5434 50.0043 50.7327 50.383C50.9221 50.7617 51.1864 51.0979 51.5097 51.3714C51.8329 51.6448 52.2084 51.8497 52.6132 51.9736C53.0181 52.0975 53.4439 52.1379 53.8647 52.0922C54.2857 52.0466 54.6929 51.9158 55.0618 51.708C61.5202 48.483 66.1994 45.0788 69.2285 40.833C72.316 36.5163 73.4577 31.6538 73.4577 25.9997V7.24967C73.4577 5.3158 72.6895 3.46114 71.322 2.09369C69.9546 0.726235 68.0988 -0.0419922 66.165  -0.0419922H49.4983C47.5644 -0.0419922 45.7097 0.726235 44.3423 2.09369C42.9748 3.46114 42.2066 5.3158 42.2066 7.24967V21.833C42.2066 25.858 45.4732 29.1247 49.4983 29.1247H67.0535Z"
      fill="white"
    />
  </svg>
);

export const linksvg = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6625 5.41179L13.5375 3.53679C14.0251 3.04926 14.6038 2.66253 15.2408 2.39868C15.8778 2.13483 16.5605 1.99902 17.25 1.99902C17.9395 1.99902 18.6222 2.13483 19.2592 2.39868C19.8962 2.66253 20.475 3.04926 20.9625 3.53679C21.4501 4.02432 21.8368 4.60311 22.1006 5.2401C22.3645 5.87709 22.5003 6.55982 22.5003 7.24929C22.5003 7.93877 22.3645 8.62149 22.1006 9.25848C21.8368 9.89547 21.4501 10.4743 20.9625 10.9618L17.2125 14.7118C16.725 15.1994 16.1462 15.5861 15.5092 15.85C14.8722 16.1139 14.1895 16.2497 13.5 16.2497C12.8105 16.2497 12.1278 16.1139 11.4908 15.85C10.8538 15.5861 10.275 15.1994 9.78752 14.7118C9.58891 14.4984 9.48075 14.2163 9.48579 13.9248C9.49083 13.6334 9.60866 13.3552 9.81452 13.1488C10.0209 12.9429 10.2991 12.8251 10.5906 12.8201C10.8821 12.815 11.1641 12.9232 11.3775 13.1218C11.6559 13.4011 11.9867 13.6227 12.351 13.7739C12.7152 13.9251 13.1057 14.0029 13.5 14.0029C13.8944 14.0029 14.2849 13.9251 14.6491 13.7739C15.0133 13.6227 15.3441 13.4011 15.6225 13.1218L19.3725 9.37179C19.9081 8.80337 20.2011 8.04868 20.1895 7.26781C20.1778 6.48693 19.8625 5.7413 19.3102 5.18908C18.758 4.63686 18.0124 4.32148 17.2315 4.30986C16.4506 4.29823 15.6959 4.59126 15.1275 5.12679L13.2525 7.00179C13.0391 7.2004 12.7571 7.30856 12.4656 7.30352C12.1741 7.29849 11.8959 7.18066 11.6895 6.97479C11.4837 6.76839 11.3658 6.49021 11.3608 6.19874C11.3558 5.90726 11.4639 5.62518 11.6625 5.41179ZM4.62752 19.8718C4.90594 20.1511 5.23674 20.3727 5.60096 20.5239C5.96518 20.6751 6.35567 20.7529 6.75002 20.7529C7.14438 20.7529 7.53486 20.6751 7.89908 20.5239C8.2633 20.3727 8.5941 20.1511 8.87252 19.8718L10.7475 17.9968C10.9609 17.7982 11.243 17.69 11.5345 17.6951C11.8259 17.7001 12.1041 17.8179 12.3105 18.0238C12.5164 18.2302 12.6342 18.5084 12.6393 18.7998C12.6443 19.0913 12.5361 19.3734 12.3375 19.5868L10.4625 21.4618C9.97499 21.9493 9.3962 22.3361 8.75921 22.5999C8.12222 22.8638 7.4395 22.9996 6.75002 22.9996C6.06055 22.9996 5.37782 22.8638 4.74083 22.5999C4.10384 22.3361 3.52506 21.9493 3.03752 21.4618C2.54999 20.9743 2.16326 20.3955 1.89941 19.7585C1.63556 19.1215 1.49976 18.4388 1.49976 17.7493C1.49976 17.0598 1.63556 16.3771 1.89941 15.7401C2.16326 15.1031 2.54999 14.5243 3.03752 14.0368L6.78752 10.2868C7.27504 9.79923 7.85382 9.41247 8.49081 9.1486C9.1278 8.88473 9.81054 8.74891 10.5 8.74891C11.1895 8.74891 11.8722 8.88473 12.5092 9.1486C13.1462 9.41247 13.725 9.79923 14.2125 10.2868C14.4111 10.5002 14.5193 10.7823 14.5143 11.0737C14.5092 11.3652 14.3914 11.6434 14.1855 11.8498C13.9791 12.0557 13.7009 12.1735 13.4095 12.1785C13.118 12.1836 12.8359 12.0754 12.6225 11.8768C12.3441 11.5975 12.0133 11.3759 11.6491 11.2247C11.2849 11.0735 10.8944 10.9957 10.5 10.9957C10.1057 10.9957 9.71518 11.0735 9.35096 11.2247C8.98674 11.3759 8.65594 11.5975 8.37752 11.8768L4.62752 15.6268C4.34824 15.9052 4.12664 16.236 3.97544 16.6002C3.82425 16.9645 3.74642 17.3549 3.74642 17.7493C3.74642 18.1436 3.82425 18.5341 3.97544 18.8983C4.12664 19.2626 4.34824 19.5934 4.62752 19.8718Z"
      fill="black"
    />
  </svg>
);

export const copylinksvg = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.80005 15.196C8.80005 11.5614 8.80005 9.74402 9.92405 8.61469C11.0494 7.48535 12.8587 7.48535 16.48 7.48535H20.32C23.94 7.48535 25.7507 7.48535 26.8747 8.61469C28 9.74402 28 11.5614 28 15.196V21.6227C28 25.2574 28 27.0747 26.8747 28.204C25.7507 29.3334 23.94 29.3334 20.32 29.3334H16.48C12.8587 29.3334 11.0494 29.3334 9.92405 28.204C8.80005 27.0747 8.80005 25.2574 8.80005 21.6227V15.196Z"
      fill="#2F57BF"
    />
    <path
      opacity="0.5"
      d="M5.56267 4.22966C4 5.79099 4 8.30566 4 13.3337V16.0003C4 21.0283 4 23.543 5.56267 25.1043C6.38533 25.9283 7.47333 26.3177 9.056 26.5017C8.8 25.3817 8.8 23.8403 8.8 21.6217V15.1963C8.8 11.5617 8.8 9.74433 9.924 8.61499C11.0493 7.48566 12.8587 7.48566 16.48 7.48566H20.32C22.5227 7.48566 24.0533 7.48566 25.1707 7.73899C24.9867 6.14833 24.5973 5.05633 23.7707 4.22966C22.2093 2.66699 19.6947 2.66699 14.6667 2.66699C9.63867 2.66699 7.124 2.66699 5.56267 4.22966Z"
      fill="#2F57BF"
    />
  </svg>
);

export const camerasvg = (
  <svg
    viewBox="0 0 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: "100%", height: "auto" }}
  >
    <g clipPath="url(#clip0_1273_39335)">
      <path
        d="M14 20.7004C15.75 20.7004 17.2377 20.0881 18.4632 18.8636C19.6887 17.6391 20.3009 16.1513 20.3 14.4004C20.2991 12.6495 19.6868 11.1622 18.4632 9.93859C17.2396 8.71499 15.7519 8.10226 14 8.10039C12.2481 8.09852 10.7609 8.71126 9.5382 9.93859C8.31553 11.1659 7.7028 12.6532 7.7 14.4004C7.6972 16.1476 8.30993 17.6353 9.5382 18.8636C10.7665 20.0919 12.2537 20.7041 14 20.7004ZM14 17.9004C13.02 17.9004 12.1917 17.5621 11.515 16.8854C10.8383 16.2087 10.5 15.3804 10.5 14.4004C10.5 13.4204 10.8383 12.5921 11.515 11.9154C12.1917 11.2387 13.02 10.9004 14 10.9004C14.98 10.9004 15.8083 11.2387 16.485 11.9154C17.1617 12.5921 17.5 13.4204 17.5 14.4004C17.5 15.3804 17.1617 16.2087 16.485 16.8854C15.8083 17.5621 14.98 17.9004 14 17.9004ZM2.8 25.6004C2.03 25.6004 1.37107 25.3265 0.8232 24.7786C0.275333 24.2307 0.000933333 23.5713 0 22.8004V6.00039C0 5.23039 0.2744 4.57146 0.8232 4.02359C1.372 3.47572 2.03093 3.20132 2.8 3.20039H7.21L9.8 0.400391H18.2L20.79 3.20039H25.2C25.97 3.20039 26.6294 3.47479 27.1782 4.02359C27.727 4.57239 28.0009 5.23132 28 6.00039V22.8004C28 23.5704 27.7261 24.2298 27.1782 24.7786C26.6303 25.3274 25.9709 25.6013 25.2 25.6004H2.8ZM2.8 22.8004H25.2V6.00039H19.53L16.975 3.20039H11.025L8.47 6.00039H2.8V22.8004Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_1273_39335">
        <rect width="28" height="26" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const arrowDown = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 7L10 14.6304L2.5 7"
      stroke="#2F57BF"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowUp = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 14.6309L10 7.00042L2.5 14.6309"
      stroke="#083098"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const scrollArrowsvg = (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.1109 9.19583L19.9998 20.5002L8.88867 9.19583M31.1109 20.5002L19.9998 31.8045L8.88867 20.5002"
      stroke="white"
      strokeWidth="1.48148"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const scrolltopsvg =  (
  <svg 
    width="27" 
    height="36" 
    viewBox="0 0 27 36" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg" 
  >
    <mask id="mask0_4040_10608" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="6" y="9" width="15" height="18">
      <path d="M12.9372 9.63605C13.1248 9.44858 13.3791 9.34326 13.6442 9.34326C13.9094 9.34326 14.1637 9.44858 14.3512 9.63605L20.0082 15.293C20.1904 15.4816 20.2912 15.7343 20.2889 15.9964C20.2866 16.2586 20.1815 16.5095 19.996 16.6949C19.8106 16.8803 19.5598 16.9854 19.2976 16.9877C19.0354 16.99 18.7828 16.8892 18.5942 16.707L14.6442 12.757L14.6442 26C14.6442 26.2653 14.5389 26.5196 14.3513 26.7072C14.1638 26.8947 13.9094 27 13.6442 27C13.379 27 13.1247 26.8947 12.9371 26.7072C12.7496 26.5196 12.6442 26.2653 12.6442 26L12.6442 12.757L8.69422 16.707C8.50562 16.8892 8.25302 16.99 7.99082 16.9877C7.72863 16.9854 7.47781 16.8803 7.29241 16.6949C7.107 16.5095 7.00183 16.2586 6.99955 15.9964C6.99727 15.7343 7.09807 15.4817 7.28022 15.293L12.9372 9.63605Z" fill="black" />
    </mask>
    <g mask="url(#mask0_4040_10608)">
      <rect width="27" height="36" fill="white" />
    </g>
  </svg>
);

export const redCross = (
  <svg
    width="27"
    height="36"
    viewBox="0 0 27 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_784_17762"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="5"
      width="26"
      height="26"
    >
      <path
        d="M11.5206 18.3536L7.20711 22.667L8.333 23.7929L12.6464 19.4794L13 19.1259L13.3536 19.4794L17.667 23.7929L18.7929 22.667L14.4794 18.3536L14.1259 18L14.4794 17.6464L18.7929 13.333L17.667 12.2071L13.3536 16.5206L13 16.8741L12.6464 16.5206L8.333 12.2071L7.20711 13.333L11.5206 17.6464L11.8741 18L11.5206 18.3536ZM25.5 18C25.5 11.0871 19.9129 5.5 13 5.5C6.08714 5.5 0.5 11.0871 0.5 18C0.5 24.9129 6.08714 30.5 13 30.5C19.9129 30.5 25.5 24.9129 25.5 18ZM23.9 18C23.9 24.0091 19.0091 28.9 13 28.9C6.99086 28.9 2.1 24.0091 2.1 18C2.1 11.9909 6.99086 7.1 13 7.1C19.0091 7.1 23.9 11.9909 23.9 18Z"
        fill="#BF3636"
        stroke="#2F57BF"
      />
    </mask>
    <g mask="url(#mask0_784_17762)">
      <rect
        width="33.2308"
        height="49.8462"
        transform="matrix(-1 0 0 1 30.1155 -6.9231)"
        fill="#BF3636"
      />
    </g>
  </svg>
);

export const minussvg = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27 15C27 15.8284 26.3284 16.5 25.5 16.5H4.5C3.67157 16.5 3 15.8284 3 15C3 14.1716 3.67157 13.5 4.5 13.5H25.5C26.3284 13.5 27 14.1716 27 15Z"
      fill="currentColor"
    />
  </svg>
);

export const plussvg = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.7188 15C26.7188 15.373 26.5706 15.7306 26.3069 15.9944C26.0431 16.2581 25.6855 16.4062 25.3125 16.4062H16.4062V25.3125C16.4062 25.6855 16.2581 26.0431 15.9944 26.3069C15.7306 26.5706 15.373 26.7188 15 26.7188C14.627 26.7188 14.2694 26.5706 14.0056 26.3069C13.7419 26.0431 13.5938 25.6855 13.5938 25.3125V16.4062H4.6875C4.31454 16.4062 3.95685 16.2581 3.69313 15.9944C3.42941 15.7306 3.28125 15.373 3.28125 15C3.28125 14.627 3.42941 14.2694 3.69313 14.0056C3.95685 13.7419 4.31454 13.5938 4.6875 13.5938H13.5938V4.6875C13.5938 4.31454 13.7419 3.95685 14.0056 3.69313C14.2694 3.42941 14.627 3.28125 15 3.28125C15.373 3.28125 15.7306 3.42941 15.9944 3.69313C16.2581 3.95685 16.4062 4.31454 16.4062 4.6875V13.5938H25.3125C25.6855 13.5938 26.0431 13.7419 26.3069 14.0056C26.5706 14.2694 26.7188 14.627 26.7188 15Z"
      fill="currentColor"
    />
  </svg>
);

export const breadcrumbsvg = (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.625 17.2493L14.375 11.4993L8.625 5.74927"
      stroke="#2F57BF"
      strokeWidth="1.52381"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const companysvg = (
  <svg
    className="custom-svg"
    viewBox="0 0 31 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.9781 9.16719C27.2312 9.16719 29.0577 7.30174 29.0577 5.00059C29.0577 2.69944 27.2312 0.833984 24.9781 0.833984C22.7249 0.833984 20.8984 2.69944 20.8984 5.00059C20.8984 7.30174 22.7249 9.16719 24.9781 9.16719Z"
      fill="currentColor"
    />
    <path
      d="M23.2324 6.22501H23.9187C23.9187 6.59559 24.3888 6.91127 24.9481 6.91127C25.5074 6.91127 25.9775 6.59559 25.9775 6.22501C25.9775 5.84756 25.6206 5.71031 24.8657 5.52845C24.1383 5.34659 23.2324 5.12012 23.2324 4.16621C23.2324 3.55201 23.7368 3.03045 24.4334 2.85545V2.10742H25.4628V2.85545C26.1593 3.03045 26.6637 3.55201 26.6637 4.16621H25.9775C25.9775 3.79563 25.5074 3.47995 24.9481 3.47995C24.3888 3.47995 23.9187 3.79563 23.9187 4.16621C23.9187 4.54366 24.2755 4.68091 25.0304 4.86277C25.7579 5.04463 26.6637 5.2711 26.6637 6.22501C26.6637 6.83921 26.1593 7.36077 25.4628 7.53577V8.2838H24.4334V7.53577C23.7368 7.36077 23.2324 6.83921 23.2324 6.22501Z"
      fill="white"
    />
    <g clipPath="url(#clip0_411_2305)">
      <path
        d="M19.2448 10.1953L21.3134 12.2639L13.686 19.901L9.54883 15.759L11.6174 13.6904L13.686 15.759L19.2448 10.1953ZM19.2448 11.5678L13.686 17.1364L11.6174 15.0923L10.9263 15.759L13.686 18.5138L19.9359 12.2639L19.2448 11.5678Z"
        fill="currentColor"
      />
    </g>
    <path
      d="M24.9796 11.2498V13.2748C24.9796 22.4413 16.8204 26.283 15.1885 26.9663C13.5567 26.283 5.39747 22.433 5.39747 13.2748V7.61657C7.11864 7.11121 8.80347 6.48472 10.4399 5.7416C12.0764 5.0191 13.6629 4.18386 15.1885 3.24164C16.3777 3.98279 17.6062 4.65604 18.8684 5.25827V5.01661C18.8692 4.50233 18.9322 3.99012 19.056 3.49163C17.8809 2.91206 16.7394 2.26378 15.6373 1.55L15.1885 1.25L14.748 1.54166C13.1636 2.56122 11.5051 3.45548 9.78714 4.21662C8.03804 5.01364 6.22902 5.66574 4.37757 6.16659L3.76562 6.32492V13.2748C3.76562 24.433 14.8051 28.6079 14.9111 28.6496L15.1885 28.7496L15.466 28.6496C15.5802 28.6496 26.6115 24.4413 26.6115 13.2748V11.0165C26.0803 11.1692 25.5314 11.2477 24.9796 11.2498Z"
      fill="currentColor"
    />
    <defs>
      <clipPath id="clip0_411_2305">
        <rect
          width="11.7645"
          height="11.7645"
          fill="white"
          transform="translate(9.54883 9.11719)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const searchsvg = (
  <svg
    width="27"
    height="36"
    viewBox="0 0 27 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_674_17155"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="3"
      width="27"
      height="32"
    >
      <path
        d="M14.9999 12V3H5.99987C5.20422 3 4.44116 3.31607 3.87855 3.87868C3.31594 4.44129 2.99987 5.20435 2.99987 6V17.4C4.54629 16.6101 6.30252 16.3284 8.01842 16.5948C9.73432 16.8612 11.3224 17.6623 12.5565 18.8839C13.7906 20.1056 14.6077 21.6854 14.8916 23.3985C15.1754 25.1116 14.9115 26.8706 14.1374 28.425L17.2304 31.5195C17.6474 31.935 17.8949 32.4585 17.9729 33H23.9999C24.7955 33 25.5586 32.6839 26.1212 32.1213C26.6838 31.5587 26.9999 30.7956 26.9999 30V15H17.9999C17.2042 15 16.4412 14.6839 15.8785 14.1213C15.3159 13.5587 14.9999 12.7956 14.9999 12ZM17.2499 12V3.75L26.2499 12.75H17.9999C17.801 12.75 17.6102 12.671 17.4695 12.5303C17.3289 12.3897 17.2499 12.1989 17.2499 12ZM6.74987 31.5C8.15163 31.502 9.51894 31.0657 10.6604 30.252L14.5799 34.17C14.6829 34.2805 14.8071 34.3692 14.9451 34.4307C15.0831 34.4922 15.232 34.5252 15.3831 34.5279C15.5341 34.5306 15.6842 34.5028 15.8243 34.4462C15.9643 34.3896 16.0916 34.3054 16.1984 34.1986C16.3053 34.0917 16.3895 33.9645 16.4461 33.8244C16.5026 33.6843 16.5304 33.5343 16.5278 33.3832C16.5251 33.2322 16.492 33.0832 16.4305 32.9452C16.3691 32.8072 16.2804 32.683 16.1699 32.58L12.2519 28.6605C13.1285 27.4271 13.5653 25.935 13.4921 24.4236C13.4189 22.9122 12.8401 21.4692 11.8484 20.3263C10.8567 19.1834 9.5098 18.4068 8.02382 18.1213C6.53785 17.8357 4.99902 18.0577 3.65437 18.7517C2.30972 19.4457 1.23724 20.5713 0.609091 21.9479C-0.0190579 23.3245 -0.166439 24.8723 0.190606 26.3427C0.547651 27.8132 1.38841 29.121 2.57793 30.0562C3.76744 30.9915 5.23671 31.5 6.74987 31.5ZM6.74987 29.25C5.55639 29.25 4.4118 28.7759 3.56789 27.932C2.72397 27.0881 2.24987 25.9435 2.24987 24.75C2.24987 23.5565 2.72397 22.4119 3.56789 21.568C4.4118 20.7241 5.55639 20.25 6.74987 20.25C7.94334 20.25 9.08793 20.7241 9.93185 21.568C10.7758 22.4119 11.2499 23.5565 11.2499 24.75C11.2499 25.9435 10.7758 27.0881 9.93185 27.932C9.08793 28.7759 7.94334 29.25 6.74987 29.25Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_674_17155)">
      <rect width="27" height="36" fill="currentColor" />
    </g>
  </svg>
);

export const filterssvg = (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5833 11.6176H8.16917M3.08133 11.6176H1M3.08133 11.6176C3.08133 10.919 3.34929 10.249 3.82626 9.75499C4.30323 9.26099 4.95013 8.98346 5.62467 8.98346C6.2992 8.98346 6.94611 9.26099 7.42308 9.75499C7.90004 10.249 8.168 10.919 8.168 11.6176C8.168 12.3162 7.90004 12.9863 7.42308 13.4803C6.94611 13.9743 6.2992 14.2518 5.62467 14.2518C4.95013 14.2518 4.30323 13.9743 3.82626 13.4803C3.34929 12.9863 3.08133 12.3162 3.08133 11.6176ZM22.5833 19.6011H15.8773M15.8773 19.6011C15.8773 20.2999 15.6087 20.9706 15.1317 21.4648C14.6546 21.9589 14.0075 22.2365 13.3328 22.2365C12.6583 22.2365 12.0114 21.9577 11.5344 21.4637C11.0575 20.9697 10.7895 20.2997 10.7895 19.6011M15.8773 19.6011C15.8773 18.9023 15.6087 18.2327 15.1317 17.7386C14.6546 17.2445 14.0075 16.9669 13.3328 16.9669C12.6583 16.9669 12.0114 17.2444 11.5344 17.7384C11.0575 18.2324 10.7895 18.9025 10.7895 19.6011M10.7895 19.6011H1M22.5833 3.63417H18.9608M13.873 3.63417H1M13.873 3.63417C13.873 2.93554 14.141 2.26553 14.6179 1.77153C15.0949 1.27753 15.7418 1 16.4163 1C16.7503 1 17.0811 1.06813 17.3896 1.20051C17.6982 1.33289 17.9786 1.52692 18.2147 1.77153C18.4509 2.01613 18.6383 2.30652 18.7661 2.62611C18.8939 2.94571 18.9597 3.28824 18.9597 3.63417C18.9597 3.98009 18.8939 4.32263 18.7661 4.64222C18.6383 4.96181 18.4509 5.2522 18.2147 5.4968C17.9786 5.74141 17.6982 5.93544 17.3896 6.06782C17.0811 6.2002 16.7503 6.26833 16.4163 6.26833C15.7418 6.26833 15.0949 5.99081 14.6179 5.4968C14.141 5.0028 13.873 4.33279 13.873 3.63417Z"
      stroke="black"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);

export const filesvg = (
  <svg
    width="40"
    height="51"
    viewBox="0 0 40 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3833_19540)">
      <path
        d="M13.3646 16.1299V19.2549H16.6979V16.1299H13.3646ZM20.0312 6.75488H16.6979V9.87988H20.0312V6.75488ZM13.3646 9.87988V13.0049H16.6979V9.87988H13.3646ZM20.0312 13.0049H16.6979V16.1299H20.0312V13.0049ZM38.5312 10.0654L29.7917 1.87207C28.8542 0.993164 27.5833 0.495117 26.2604 0.495117H5C2.23958 0.504883 0 2.60449 0 5.19238V45.8174C0 48.4053 2.23958 50.5049 5 50.5049H35C37.7604 50.5049 40 48.4053 40 45.8174V13.3857C40 12.1455 39.4688 10.9443 38.5312 10.0654ZM26.6667 5.57324L34.5938 13.0049H26.6667V5.57324ZM35 45.8174H5V5.19238H13.3021V6.75488H16.6354V5.19238H21.6667V15.3486C21.6667 16.6475 22.7812 17.6924 24.1667 17.6924H35V45.8174ZM20.2292 26.4522C20.1146 25.9053 19.6042 25.5049 19 25.5049H16.6979V22.3799H13.3646V25.5049L11.3125 34.9873C10.625 38.1611 13.2083 41.1299 16.6667 41.1299C20.1146 41.1299 22.6979 38.1807 22.0312 35.0166L20.2292 26.4522ZM16.6979 38.6006C14.8333 38.6006 13.3229 37.4189 13.3229 35.9639C13.3229 34.5088 14.8333 33.3271 16.6979 33.3271C18.5625 33.3271 20.0729 34.5088 20.0729 35.9639C20.0729 37.4189 18.5625 38.6006 16.6979 38.6006ZM20.0312 19.2549H16.6979V22.3799H20.0312V19.2549Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3833_19540">
        <rect
          width="40"
          height="50.0098"
          fill="white"
          transform="translate(0 0.495117)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const selectFilesvg = (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 2.08301H32.1125L43.75 13.7205V24.9997H39.5833V18.7497H27.0833V6.24967H10.4167V43.7497H25V47.9163H6.25V2.08301ZM31.25 7.11217V14.583H38.7208L31.25 7.11217ZM29.1667 32.2913C29.1667 30.91 29.7154 29.5852 30.6922 28.6085C31.6689 27.6317 32.9937 27.083 34.375 27.083C35.7563 27.083 37.0811 27.6317 38.0578 28.6085C39.0346 29.5852 39.5833 30.91 39.5833 32.2913V41.6663H35.4167V32.2913C35.4167 32.0151 35.3069 31.7501 35.1116 31.5548C34.9162 31.3594 34.6513 31.2497 34.375 31.2497C34.0987 31.2497 33.8338 31.3594 33.6384 31.5548C33.4431 31.7501 33.3333 32.0151 33.3333 32.2913V41.6663C33.3333 42.7714 33.7723 43.8312 34.5537 44.6126C35.3351 45.394 36.3949 45.833 37.5 45.833C38.6051 45.833 39.6649 45.394 40.4463 44.6126C41.2277 43.8312 41.6667 42.7714 41.6667 41.6663V33.333H45.8333V41.6663C45.8333 43.8765 44.9554 45.9961 43.3926 47.5589C41.8298 49.1217 39.7101 49.9997 37.5 49.9997C35.2899 49.9997 33.1702 49.1217 31.6074 47.5589C30.0446 45.9961 29.1667 43.8765 29.1667 41.6663V32.2913Z"
      fill="white"
    />
  </svg>
);

export const paypalIconsvg = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 92 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_659_16608)">
      <path d="M5 20H50L51 25.7391L50 31V42H5V20Z" fill="#283B82" />
      <path d="M51 20H88.1739L89 25.7391L88.1739 31V42H51V20Z" fill="#469BDB" />
      <path
        d="M29.7562 30.0148C29.7562 31.6492 28.2066 32.8931 26.2429 32.8931C24.7738 32.8931 23.6871 32.1964 23.6871 30.885C23.6871 29.2506 25.2051 27.9393 27.1543 27.9393C28.6407 27.9393 29.7562 28.7034 29.7562 30.0148ZM12.8569 23.5206H12.1066C11.8679 23.5206 11.6264 23.6556 11.5948 23.8822L10.9077 27.4596L12.2187 27.4186C13.9753 27.4186 15.3323 27.2185 15.6514 25.5166C16.0194 23.7207 14.6624 23.5206 12.8569 23.5206ZM58.2187 23.5206H57.4999C57.2124 23.5206 57.0198 23.6556 56.9882 23.8822L56.3183 27.4596L57.5948 27.4186C59.6706 27.4186 61.1081 27.016 61.1081 25.008C61.0908 23.5881 59.5786 23.5206 58.2187 23.5206ZM91.9999 6.14979V53.2916C91.9992 54.9965 91.1911 56.6314 89.7533 57.837C88.3155 59.0425 86.3657 59.7201 84.3323 59.7207H7.66469C5.63135 59.7201 3.6815 59.0425 2.24371 57.837C0.805914 56.6314 -0.00216771 54.9965 -0.00292969 53.2916V6.14979C-0.00216771 4.44489 0.805914 2.81 2.24371 1.60445C3.6815 0.398896 5.63135 -0.278658 7.66469 -0.279297H84.3323C86.3657 -0.278658 88.3155 0.398896 89.7533 1.60445C91.1911 2.81 91.9992 4.44489 91.9999 6.14979ZM20.4929 24.2824C20.4929 21.4692 17.9054 20.5315 14.9499 20.5315H8.5617C8.35533 20.5328 8.15672 20.5976 8.00356 20.7136C7.85041 20.8296 7.75335 20.9886 7.73082 21.1606L5.1117 34.8336C5.06282 35.1012 5.30432 35.3688 5.62345 35.3688H8.65945C9.0907 35.3688 9.49032 34.9806 9.5392 34.6046L10.2579 31.0417C10.4189 30.0775 12.3653 30.4126 13.1329 30.4126C17.7013 30.4126 20.4958 28.1369 20.4958 24.28L20.4929 24.2824ZM33.9422 25.4612H30.9062C30.2996 25.4612 30.2679 26.1988 30.2363 26.5604C29.3106 25.4226 27.9679 25.2201 26.4499 25.2201C22.5371 25.2201 19.5499 28.0984 19.5499 31.2731C19.5499 33.8838 21.4992 35.5857 24.6128 35.5857C26.0503 35.5857 27.8386 34.93 28.8448 33.9923C28.7519 34.2632 28.6979 34.5424 28.6838 34.824C28.6838 35.1325 28.8448 35.3591 29.1956 35.3591H31.9441C32.3753 35.3591 32.7433 34.971 32.8238 34.595L34.4539 25.9843C34.5028 25.7287 34.2613 25.4612 33.9422 25.4612ZM40.4109 38.5725L50.5856 26.1699C50.6661 26.1024 50.6661 26.0349 50.6661 25.9433C50.6661 25.7167 50.4274 25.4756 50.1543 25.4756H47.0867C46.944 25.4803 46.8045 25.5131 46.6797 25.5713C46.5548 25.6295 46.448 25.7115 46.3679 25.8107L42.1359 31.0345L40.3793 26.0132C40.3133 25.8605 40.1942 25.7278 40.0374 25.6324C39.8806 25.537 39.6932 25.4833 39.4996 25.478H36.5124C36.2393 25.478 36.0007 25.7191 36.0007 25.9457C36.0007 26.1072 39.1143 33.5536 39.3874 34.2623C38.9562 34.7709 36.1128 38.0927 36.1128 38.4953C36.1128 38.7364 36.3514 38.9244 36.6246 38.9244H39.6922C39.8357 38.9165 39.9751 38.8811 40.0997 38.8209C40.2243 38.7607 40.3308 38.6774 40.4109 38.5773V38.5725ZM65.8547 24.2824C65.8547 21.4692 63.2672 20.5315 60.3117 20.5315H53.9694C53.7571 20.53 53.5512 20.5929 53.3896 20.7084C53.228 20.824 53.1215 20.9846 53.0897 21.1606L50.5022 34.8215C50.4706 35.0891 50.7092 35.3567 51.0139 35.3567H54.2886C54.6077 35.3567 54.8463 35.1566 54.9268 34.9276L55.6456 31.0441C55.8066 30.0799 57.7558 30.415 58.5206 30.415C63.0573 30.415 65.8547 28.1393 65.8547 24.2824ZM79.3011 25.4612H76.2651C75.6584 25.4612 75.6268 26.1988 75.5779 26.5604C74.6982 25.4226 73.3412 25.2201 71.7916 25.2201C67.8787 25.2201 64.8916 28.0984 64.8916 31.2731C64.8916 33.8838 66.8408 35.5857 69.9544 35.5857C71.4408 35.5857 73.2291 34.93 74.1864 33.9923C74.1376 34.1924 74.0254 34.6215 74.0254 34.824C74.0254 35.1325 74.1864 35.3591 74.5372 35.3591H77.3001C77.7313 35.3591 78.0993 34.971 78.1798 34.595L79.8099 25.9843C79.8588 25.7287 79.6202 25.4612 79.3011 25.4612ZM86.8882 21.0015C86.8882 20.734 86.6496 20.5339 86.3764 20.5339H83.4209C83.1823 20.5339 82.9408 20.6954 82.9092 20.8955L80.3217 34.824L80.2757 34.8915C80.2757 35.1325 80.5143 35.3591 80.8334 35.3591H83.4698C83.8694 35.3591 84.2691 34.971 84.3007 34.595L86.8882 21.0425V21.0015ZM72.5132 27.9393C70.5639 27.9393 69.0459 29.2386 69.0459 30.885C69.0459 32.1843 70.1643 32.8931 71.6334 32.8931C73.5511 32.8931 75.1007 31.6612 75.1007 30.0148C75.1179 28.7034 73.9996 27.9393 72.5132 27.9393Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_659_16608">
        <rect width="92" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const gPaysvg = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 92 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="90" height="58" rx="4" fill="white" />
    <rect
      x="1"
      y="1"
      width="100%"
      height="100%"
      rx="4"
      stroke="white"
      strokeWidth="2"
    />
    <g clipPath="url(#clip0_674_17123)">
      <path
        d="M60.6185 23.8267C62.5429 23.8267 64.0299 24.3724 65.1672 25.4639C66.3043 26.5552 66.829 28.0105 66.829 29.8295V38.5608H64.3798V36.5601H64.2923C63.2427 38.1973 61.7556 39.0158 60.0062 39.0158C58.5191 39.0158 57.207 38.5609 56.1574 37.6516C55.1952 36.742 54.5828 35.4687 54.5828 34.1045C54.5828 32.6492 55.1078 31.4667 56.1574 30.5572C57.207 29.6477 58.6941 29.2839 60.4435 29.2839C62.018 29.2839 63.2427 29.5569 64.2048 30.1934V29.5569C64.2048 28.7079 63.9001 27.8591 63.2904 27.306L63.1551 27.1921C62.4554 26.5554 61.5806 26.1916 60.6185 26.1916C59.1314 26.1916 57.9944 26.8283 57.207 28.1016L54.9328 26.6461C56.3323 24.736 58.1692 23.8267 60.6185 23.8267ZM48.2849 17.6418C49.8544 17.6418 51.346 18.2098 52.5386 19.2688L52.746 19.4607C53.9706 20.5522 54.5828 22.1894 54.5828 23.9175C54.5828 25.6456 53.9706 27.1918 52.746 28.3741C51.5213 29.5566 50.0343 30.1932 48.2849 30.1932L44.0862 30.1022V38.5608H41.4619V17.6418H48.2849ZM60.9683 31.4666C59.9187 31.4666 59.0439 31.7394 58.3442 32.2851C57.6444 32.7399 57.2945 33.3765 57.2945 34.195C57.2945 34.9227 57.6445 35.5593 58.1692 35.9232C58.7816 36.378 59.4813 36.6508 60.1812 36.6508C61.1608 36.6508 62.1405 36.2546 62.9068 35.5363L63.0677 35.3775C63.9424 34.5589 64.3798 33.5584 64.3798 32.467C63.5926 31.8304 62.4554 31.4665 60.9684 31.4665M48.46 20.1883H44.0864V27.4649H48.46C49.4221 27.4649 50.3843 27.1011 50.9967 26.3735C52.3961 25.0093 52.3961 22.7355 51.0842 21.371L50.9967 21.2801C50.2968 20.5525 49.4221 20.0977 48.4599 20.1887M80.9996 24.2814L72.3398 44.9276H69.7157L72.9521 37.7424L67.2663 24.3724H70.0655L74.1767 34.6499H74.2642L78.2879 24.3724H80.9996V24.2814Z"
        fill="#5F6368"
      />
      <path
        d="M33.6772 28.2833C33.6772 27.4647 33.5897 26.6462 33.5022 25.8276H22.5684V30.4662H28.7788C28.5164 31.9213 27.7292 33.2856 26.5046 34.1043V37.1057H30.2659C32.4527 35.0138 33.6773 31.9213 33.6773 28.2834"
        fill="#4285F4"
      />
      <path
        d="M22.5688 40.0163C25.7177 40.0163 28.3419 38.9249 30.2663 37.1058L26.5051 34.1045C25.4553 34.832 24.1432 35.2868 22.5688 35.2868C19.5946 35.2868 16.9704 33.1949 16.0957 30.2844H12.2471V33.3768C14.2589 37.4696 18.1952 40.0163 22.5688 40.0163Z"
        fill="#34A853"
      />
      <path
        d="M16.0952 30.2844C15.5705 28.8291 15.5705 27.192 16.0952 25.6458V22.5535H12.2466C10.5845 25.9187 10.5845 29.9206 12.2466 33.3767L16.0952 30.2844Z"
        fill="#FBBC04"
      />
      <path
        d="M22.5683 20.7344C24.2303 20.7344 25.8047 21.3712 27.0295 22.5535L30.3534 19.0974C28.2539 17.0964 25.4549 15.914 22.6557 16.0049C18.2821 16.0049 14.2584 18.5516 12.334 22.6445L16.1828 25.7368C16.97 22.8263 19.5942 20.7344 22.5683 20.7344Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_674_17123">
        <rect
          width="70"
          height="29"
          fill="white"
          transform="translate(11 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const applePaysvg = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 92 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="92" height="60" rx="5" fill="white" />
    <mask
      id="mask0_659_16621"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="1"
      width="92"
      height="58"
    >
      <path
        d="M8.24167 1.19292C7.66154 1.19361 7.08142 1.19736 6.50133 1.20417C5.92633 1.22292 5.33983 1.25292 4.76867 1.35417C3.90547 1.48761 3.087 1.81964 2.38059 2.32294C1.67418 2.82624 1.10002 3.48642 0.705333 4.24917C0.437 4.76667 0.268333 5.29167 0.168667 5.86167C0.0613333 6.41667 0.0268333 6.98667 0.0153333 7.54917C0.00748577 7.81036 0.00237439 8.07163 0 8.33292L0 51.6717C0 51.9342 0.00766667 52.1892 0.0115 52.4479C0.0268333 53.0104 0.0613333 53.5842 0.164833 54.1429C0.268333 54.7054 0.440833 55.2342 0.709167 55.7517C1.23776 56.7697 2.08348 57.5971 3.12417 58.1142C3.65317 58.3767 4.18983 58.5454 4.7725 58.6467C5.33983 58.7479 5.9225 58.7817 6.4975 58.7967L7.29483 58.8079H84.7052L85.4987 58.7967C86.0737 58.7817 86.6602 58.7479 87.2313 58.6467C87.8063 58.5454 88.3468 58.3804 88.872 58.1179C89.9153 57.6013 90.7628 56.7723 91.2908 55.7517C91.5592 55.2342 91.7317 54.7092 91.8313 54.1392C91.9348 53.5842 91.9693 53.0142 91.9847 52.4517C91.9923 52.1892 91.9962 51.9342 91.9962 51.6717L92 50.7492V8.32917C92 8.06667 91.9923 7.81167 91.9847 7.55292C91.9774 6.98494 91.9262 6.41831 91.8313 5.85792C91.6479 4.72864 91.1043 3.68497 90.2781 2.8761C89.452 2.06722 88.3856 1.53453 87.2313 1.35417C86.6584 1.26176 86.0792 1.21162 85.4987 1.20417C84.92 1.18814 84.341 1.18439 83.7622 1.19292H8.24167ZM8.24167 3.11292H84.686C84.939 3.11292 85.1882 3.12042 85.4412 3.12417C85.882 3.13917 86.3995 3.16167 86.8787 3.24417C87.2965 3.31917 87.6453 3.43167 87.9788 3.59667C88.6513 3.93059 89.1977 4.46511 89.539 5.12292C89.7146 5.46286 89.8362 5.82706 89.8993 6.20292C89.9837 6.66417 90.0067 7.17042 90.0182 7.60542C90.0258 7.84917 90.0297 8.09292 90.0297 8.34417V51.6642C90.0297 51.9079 90.0297 52.1517 90.0182 52.3992C90.0067 52.8304 89.9837 53.3367 89.8955 53.8054C89.8126 54.3572 89.5951 54.8814 89.2615 55.3337C88.9279 55.786 88.488 56.1532 87.9788 56.4042C87.6336 56.575 87.264 56.6939 86.8825 56.7567C86.4095 56.8303 85.9316 56.8704 85.4527 56.8767L84.686 56.8879H7.30633C7.05333 56.8879 6.7965 56.8804 6.555 56.8767C6.07351 56.8706 5.59309 56.8305 5.1175 56.7567C4.69967 56.6817 4.35083 56.5692 4.0135 56.4042C3.34107 56.0715 2.79553 55.5366 2.45717 54.8779C2.28202 54.5378 2.16053 54.1737 2.09683 53.7979C2.0207 53.3353 1.9797 52.8677 1.97417 52.3992C1.96902 52.153 1.96647 51.9067 1.9665 51.6604V8.34042C1.9665 8.09667 1.9665 7.84917 1.97417 7.60167C1.9895 7.17417 2.0125 6.67167 2.09683 6.19542C2.1735 5.79042 2.2885 5.44917 2.45717 5.11917C2.79872 4.46245 3.34518 3.92918 4.01733 3.59667C4.36436 3.42693 4.73507 3.30815 5.1175 3.24417C5.59667 3.16167 6.11417 3.13542 6.555 3.12417C6.80417 3.11667 7.05717 3.11667 7.30633 3.11292H8.24167ZM26.2967 16.9879C25.1467 17.0479 23.736 17.7342 22.9233 18.6979C22.1912 19.5229 21.5433 20.8729 21.712 22.1404C23.0077 22.2529 24.2995 21.5067 25.116 20.5729C25.9018 19.6054 26.4385 18.3117 26.2967 16.9917V16.9879ZM34.7568 18.5629V39.1617H38.0228V32.1229H42.5462C46.6785 32.1229 49.5803 29.3517 49.5803 25.3279C49.5803 21.3154 46.736 18.5592 42.6497 18.5592L34.7568 18.5629ZM38.0228 21.2592H41.7872C44.62 21.2592 46.2377 22.7442 46.2377 25.3429C46.2377 27.9379 44.62 29.4379 41.7757 29.4379H38.0228V21.2592ZM25.9325 22.3842C24.2075 22.4217 22.7508 23.4342 21.9075 23.4342C21.0067 23.4342 19.6343 22.4442 18.147 22.4704C17.1795 22.494 16.2352 22.7651 15.408 23.2565C14.5808 23.748 13.8995 24.4427 13.432 25.2717C11.4118 28.6767 12.8992 33.7279 14.8657 36.5029C15.8202 37.8754 16.9702 39.3867 18.4843 39.3304C19.9142 39.2779 20.4777 38.4229 22.2142 38.4229C23.9545 38.4229 24.4605 39.3304 25.9708 39.3042C27.5425 39.2779 28.5277 37.9317 29.4783 36.5554C30.5747 34.9917 31.0232 33.4804 31.05 33.4017C31.0232 33.3717 28.0217 32.2467 27.9948 28.8679C27.9642 26.0404 30.3523 24.6942 30.4635 24.6117C29.1142 22.6617 27.0135 22.4442 26.2852 22.3879C26.1678 22.3807 26.0501 22.382 25.9325 22.3842ZM57.3812 23.8729C53.5862 23.8729 51.2248 25.8717 51.0485 28.5829H54.027C54.303 27.2404 55.4415 26.3854 57.2662 26.3854C59.1905 26.3854 60.3443 27.3829 60.3443 29.0517V30.2104L56.1392 30.4504C52.4937 30.6529 50.4352 32.2654 50.4352 34.8904C50.4352 37.5904 52.5358 39.4167 55.5412 39.4167C57.5575 39.4167 59.4972 38.3629 60.3865 36.6904H60.4593V39.1617H63.48V28.8117C63.48 25.8004 61.1033 23.8729 57.3812 23.8729ZM64.8178 24.1429L70.3608 39.1767C70.3608 39.1879 70.081 40.0767 70.081 40.1029C69.6018 41.6404 68.816 42.2442 67.3555 42.2442C67.091 42.2442 66.5658 42.2442 66.332 42.1879V44.6854C66.562 44.7267 67.3555 44.7567 67.6162 44.7567C70.7978 44.7567 72.3158 43.5867 73.6268 39.9454L79.3768 24.1429H76.0495L72.1702 36.3642H72.1127L68.2295 24.1392L64.8178 24.1429ZM60.3443 32.3517V33.5367C60.3443 35.4904 58.6193 36.9754 56.419 36.9754C54.7247 36.9754 53.6168 36.1204 53.6168 34.8042C53.6168 33.5217 54.6825 32.7042 56.5647 32.5804L60.3443 32.3517Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_659_16621)">
      <rect x="11" y="12.5811" width="70" height="33.871" fill="#505050" />
    </g>
  </svg>
);

export const spoilerbtnopen = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 85 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.3305 20.9199L43.3305 60.7599M43.3305 60.7599L58.2705 42.3359M43.3305 60.7599L28.3905 42.3359M84 42.5C84 65.4198 65.4198 84 42.5 84C19.5802 84 1 65.4198 1 42.5C1 19.5802 19.5802 1 42.5 1C65.4198 1 84 19.5802 84 42.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const spoilerbtnclose = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 85 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.3305 64.0801L43.3305 24.2401M43.3305 24.2401L58.2705 42.6641M43.3305 24.2401L28.3905 42.6641M84 42.5C84 19.5802 65.4198 1 42.5 1C19.5802 1 1 19.5802 1 42.5C1 65.4198 19.5802 84 42.5 84C65.4198 84 84 65.4198 84 42.5Z"
      stroke="#083098"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


export const burgersvg =(
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 9H30M6 18H30M6 27H30" stroke="white" strokeWidth="1.6" strokeLinecap="round"/>
</svg>

)
